exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ni[style=\"background-image: url('/uarm-fe/uarm-images/tinymce-typograph.png')\"] {\n\twidth: 48px;\n}\n.tooltip-ask {\n\twidth: 20px;\n\theight: 14px;\n\tdisplay: inline-block;\n}\n", ""]);
